/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Extend the existing ModalManager functionalityclass TradeShowModalManager {
document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("modal-trade-show-selector");
  const tradeShowSelector = document.getElementById("trade-show-selector");
  const tradeShowConfirm = document.getElementById("trade-show-confirm");
  const tradeShowButtons = document.querySelectorAll(
    ".m-button--header-trade-show"
  );

  // Helper function to get cookies
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  };

  // Helper function to set cookies
  const setCookie = (name, value, days) => {
    const expires = new Date(Date.now() + days * 86400000).toUTCString();
    const domain = ".dbstores.com"; // Explicitly define the root domain for cookies
    document.cookie = `${name}=${value}; path=/; domain=${domain}; expires=${expires}; Secure; SameSite=Lax`;
  };

  // Ensure the modal and buttons exist before running logic
  if (modal && tradeShowSelector && tradeShowConfirm) {
    const currentHost = window.currentHost || window.location.hostname;
    const subdomain = currentHost.split(".")[0];
    const validSubdomains = [
      "dbmagicmiami",
      "dbmagicnewyork",
      "dbtextworldnewyork",
      "dbmagicnashville",
      "dbmagiclasvegas",
      "dealsbydb",
    ];

    // Check if a cookie for the selected trade show exists
    const selectedTradeShowCookie = getCookie("selectedTradeShow");

    // Prevent infinite reload: Only redirect if the cookie doesn't match the current subdomain
    if (
      selectedTradeShowCookie &&
      validSubdomains.includes(selectedTradeShowCookie) &&
      selectedTradeShowCookie !== subdomain
    ) {
      console.log(`Redirecting to subdomain: ${selectedTradeShowCookie}`);
      const redirectUrl = `https://${selectedTradeShowCookie}.dbstores.com`;
      window.location.href = redirectUrl;
      return; // Stop further execution to prevent reload loops
    }

    // // Show modal for users on main domain or undefined subdomains
    // if (!validSubdomains.includes(subdomain)) {
    //   console.log(
    //     "Showing modal: User is on the main domain or invalid subdomain."
    //   );
    //   modal.setAttribute("aria-hidden", "false");
    //   modal.style.display = "flex";
    //   document.documentElement.classList.add("is-locked");
    // }

    // Add event listener to desktop button to open modal
    if (tradeShowButtons.length > 0) {
      tradeShowButtons.forEach((button) => {
        button.addEventListener("click", () => {
          console.log("Opening modal via trade show button.");
          modal.setAttribute("aria-hidden", "false");
          modal.style.display = "flex";
          document.documentElement.classList.add("is-locked");
        });
      });
    }

    // Add event listener to confirm button in modal
    tradeShowConfirm.addEventListener("click", () => {
      const selectedTradeShow = tradeShowSelector.value;

      if (!selectedTradeShow) {
        alert("Please select a trade show!");
        return;
      }

      // Save the selected trade show in cookies
      setCookie("selectedTradeShow", selectedTradeShow, 365); // 1-year validity

      // Redirect to subdomain
      const redirectUrl = `https://${selectedTradeShow}.dbstores.com`;

      console.log(`Redirecting to: ${redirectUrl}`);
      window.location.href = redirectUrl;
    });
  } else {
    console.warn(
      "Modal, selector, confirm button, or header button is not present on this page."
    );
  }
});

// This script ensures company name and booth number are saved to the cart note
// for display on packing slips, without overwriting existing notes or functionality

document.addEventListener('DOMContentLoaded', function() {
  // Find the checkout buttons
  const checkoutButtons = document.querySelectorAll('button[name="checkout"]');
  
  // Find the company name and booth number fields
  const companyInput = document.getElementById('company-name');
  const boothInput = document.getElementById('booth-number');
  
  // Exit if we can't find the checkout buttons or company input
  if (!checkoutButtons.length || !companyInput) {
    console.log('Packing slip info: Required elements not found');
    return;
  }
  
  // Function to safely append info to note without overwriting existing content
  async function appendToNote() {
    try {
      // Get the company name and booth number
      const companyName = companyInput.value.trim();
      const boothNumber = boothInput ? boothInput.value.trim() : '';
      
      // Don't proceed if no company name
      if (!companyName) {
        return;
      }
      
      // Get current cart to check the note
      const response = await fetch('/cart.js');
      const cart = await response.json();
      let note = cart.note || '';
      
      // Format the information we want to add
      let packingSlipInfo = '';
      
      // Check if note already contains company name or booth number
      const hasCompanyInfo = note.includes('Company Name:');
      const hasBoothInfo = note.includes('Booth Number:');
      
      // If we already have both pieces of info in the note, no need to modify
      if (hasCompanyInfo && (hasBoothInfo || !boothNumber)) {
        return;
      }
      
      // Split note into lines for better manipulation
      let noteLines = note.split('\n');
      
      // If we need to add/update company name
      if (!hasCompanyInfo) {
        noteLines.push(`Company Name: ${companyName}`);
      } else {
        // Update existing company name line
        for (let i = 0; i < noteLines.length; i++) {
          if (noteLines[i].includes('Company Name:')) {
            noteLines[i] = `Company Name: ${companyName}`;
            break;
          }
        }
      }
      
      // If we need to add/update booth number
      if (boothNumber && !hasBoothInfo) {
        noteLines.push(`Booth Number: ${boothNumber}`);
      } else if (boothNumber) {
        // Update existing booth number line
        let foundBooth = false;
        for (let i = 0; i < noteLines.length; i++) {
          if (noteLines[i].includes('Booth Number:')) {
            noteLines[i] = `Booth Number: ${boothNumber}`;
            foundBooth = true;
            break;
          }
        }
        
        // If somehow we didn't find it but hasBoothInfo was true, add it
        if (!foundBooth) {
          noteLines.push(`Booth Number: ${boothNumber}`);
        }
      }
      
      // Rebuild the note
      note = noteLines.join('\n').trim();
      
      // Update the cart note, but don't affect other attributes
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          note: note
        })
      });
      
      console.log('Packing slip info: Cart note updated successfully');
    } catch (error) {
      console.error('Packing slip info: Error updating cart note:', error);
    }
  }
  
  // Add event listeners to checkout buttons
  checkoutButtons.forEach(button => {
    button.addEventListener('click', async function(e) {
      // Don't prevent default - let other scripts handle validation
      // Just append our info to the note before checkout proceeds
      
      // Add a slight delay to ensure our code runs after validation
      // but before the form submits (in case other scripts prevent default)
      setTimeout(async function() {
        await appendToNote();
      }, 10);
    });
  });
  
  // Also update note when fields lose focus (for added reliability)
  companyInput.addEventListener('blur', appendToNote);
  if (boothInput) {
    boothInput.addEventListener('blur', appendToNote);
  }
});